// 用户中心-基本信息
import _axios from "../../index";
import qs from 'qs'

//其他信息
export const userProfile = data =>
    _axios({
        url: "/userProfile/info",
        method: "get",
        data: data
    });

//绑定用户名
export const bindUserName = data =>
    _axios({
        url: "bind/username",
        method: "post",
        data: qs.stringify(data)
    });

//认证信息-企业
export const identification = data =>
    _axios({
        url: "identification/info",
        method: "get",
        params: data
    });

//更新用户扩展信息
export const userProfilePut = data =>
    _axios({
        url: "userProfile",
        method: "put",
        data: data
    });


//获取用户协议相关基本信息
export const signUserInfo = () =>
    _axios({
        url: "/userInfo",
        method: "get",
    });

//子账号添加协议
export const signProtocol = (data) =>
    _axios({
        url: '/sign/signProtocol',
        method: "post",
        data:qs.stringify(data)
    });


